import { Box, PopoverMenu, Text } from '@wix/design-system';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';
import { ChevronLeft, ChevronRight, Languages } from 'wix-ui-icons-common';

import { LOCALES, PRODUCTION_DOMAIN } from '../../../../constants';
import { DATA_HOOKS } from '../../../../dataHooks';
import { isRTL } from '../../../../utils/internationalization';
import { useStore } from '../../../../zustand/stores';
import { useHeaderBI } from '../../bi';

import css from './index.module.scss';

export const LANGUAGE_NAMES: Record<string, string> = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  he: 'עברית',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  nl: 'Nederlands',
  pt: 'Português',
  ru: 'Русский',
  tr: 'Türkçe',
  uk: 'Українська',
};

export const LanguageMenu: FunctionComponent = () => {
  const { asPath, locale } = useRouter();
  const { user } = useStore((state) => state.userSlice);
  const isRTLLanguage = isRTL(locale);
  const { onLinkClick } = useHeaderBI();

  const onLanguageChange = async (language: string) => {
    const url = `/${language}${asPath === '/' ? '' : asPath}`;
    await onLinkClick(
      LANGUAGE_NAMES[language],
      `https://${PRODUCTION_DOMAIN}${url}`
    );
    location.href = url;
  };

  return (
    <PopoverMenu
      className={css.languageMenu}
      dataHook={DATA_HOOKS.HEADER_LANGUAGE_MENU}
      placement={user !== null ? 'left' : 'bottom'}
      moveBy={user !== null ? { x: 0, y: 20 } : { x: 0, y: 0 }}
      showArrow={!user !== null}
      triggerElement={({ open, close, toggle }) =>
        user !== null ? (
          <div
            onMouseEnter={open}
            onMouseLeave={close}
            onClick={toggle}
            className={css.loggedInButton}
            data-hook={DATA_HOOKS.HEADER_LANGUAGE_MENU_BUTTON}
          >
            <Box gap={1} position="relative">
              <Languages
                color="#000624"
                className={css.langaugesMenuIconLoggedIn}
              />
              <Text className={css.languageMenuText}>
                {LANGUAGE_NAMES[locale as string]}
              </Text>
            </Box>
            {isRTLLanguage ? (
              <ChevronLeft color="#000624" />
            ) : (
              <ChevronRight color="#000624" />
            )}
          </div>
        ) : (
          <Languages
            onClick={toggle}
            data-hook={DATA_HOOKS.HEADER_LANGUAGE_MENU_BUTTON}
            className={css.languageMenuIcon}
          />
        )
      }
    >
      {Object.values(LOCALES).map((lang) => (
        <PopoverMenu.MenuItem
          key={lang}
          onClick={() => onLanguageChange(lang)}
          text={
            <div
              className={classNames(css.language, {
                [css.selectedLanguage]: locale === lang,
              })}
            >
              {LANGUAGE_NAMES[lang]}
            </div>
          }
        />
      ))}
    </PopoverMenu>
  );
};
